import React from 'react';
import { cn } from '../../../components/ui/_cn';

// Loading placeholders on the Finance palette. SkeletonBlock (the app's) is
// slate; these are the same idea on the hairline tone.
export const FinSkeletonLine = ({ className = '' }) => (
  <div className={cn('animate-pulse rounded bg-fin-hair', className)} aria-hidden="true" />
);

// `role="status"`: the QA harness waits for every status role to leave the
// page before it reads a table, the way it already does for the section
// skeletons.
export const FinTableSkeleton = ({ rows = 5 }) => (
  <div role="status" aria-label="Loading" className="divide-y divide-fin-hair">
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="flex h-[46px] items-center">
        <div className="h-3 w-full animate-pulse rounded bg-fin-hair" />
      </div>
    ))}
  </div>
);
